import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const PURCHASES = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Lucía',
  city: 'Córdoba'
}, {
  name: 'Diego',
  city: 'Rosario'
}, {
  name: 'Camila',
  city: 'Mendoza'
}, {
  name: 'Fernando',
  city: 'La Plata'
}, {
  name: 'Sofía',
  city: 'Mar del Plata'
}, {
  name: 'Alejandro',
  city: 'Tucumán'
}, {
  name: 'Valentina',
  city: 'Salta'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 15000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    // Pick a random purchase
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 15 and 35 seconds
      const nextDelay = Math.floor(Math.random() * 20000) + 15000;
      setTimeout(showNextPopup, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500 max-w-sm" data-id="element-223">
      <div className="bg-[#132847] rounded-lg shadow-2xl border border-[#1E3A5F] p-4 pr-10 relative flex items-start gap-3" data-id="element-224">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-300" aria-label="Cerrar notificación" data-id="element-225">
          <X className="w-4 h-4" data-id="element-226" />
        </button>

        <div className="bg-green-900/50 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-227">
          <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-228" />
        </div>

        <div data-id="element-229">
          <p className="text-sm font-medium text-white" data-id="element-230">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-400 mt-0.5" data-id="element-231">
            Acaba de comprar el Método Detailing Pro
          </p>
          <p className="text-[10px] text-gray-500 mt-1" data-id="element-232">Hace unos minutos</p>
        </div>
      </div>
    </div>;
}